const getTimeStamp = (dateTime,long,includeAgo,textOnly) => {
    const now = new Date();
    const difference = now - dateTime;
    const diffSecs = Math.floor(difference/1000);
    var timeToDisplay = '';
    var units = '';
    if(diffSecs < 60){
        timeToDisplay = diffSecs;
        units = 's';
    } else if (diffSecs < 3600) {
        timeToDisplay = Math.floor(diffSecs/60);
        units = 'm';
    } else if (diffSecs < 3600*24) {
        timeToDisplay = Math.floor(diffSecs/(60*60));
        units = 'h';
    } else if (diffSecs < 3600*24*7) {
        timeToDisplay = Math.floor(diffSecs/(60*60*24));
        units = 'd';
    } else {
        timeToDisplay = Math.round(diffSecs/(60*60*24*7));
        units = 'w';
    }
    if(dateTime){
        if(!(dateTime instanceof Date)){
            dateTime = new Date(dateTime);
        }
        if(textOnly){
            if(long){
                return `${dateTime.toLocaleDateString('en-GB',{weekday: 'short', day:'numeric', month:'short', year:'numeric'}).replace(',','')} ${dateTime.toLocaleTimeString('en-GB',{ hour: "2-digit", minute: "2-digit" }).replace(',','')} (${timeToDisplay}${units} ${includeAgo? 'ago' : ''})`
            } else {
                return `${timeToDisplay}${units} ${includeAgo? 'ago' : ''}`
            }
        } else {
            if(long){
                return <><span>{dateTime.toLocaleDateString('en-GB',{weekday: 'short', day:'numeric', month:'short', year:'numeric'}).replace(',','')}</span> {dateTime.toLocaleTimeString('en-GB',{ hour: "2-digit", minute: "2-digit" }).replace(',','')} <em>({timeToDisplay}{units} {includeAgo? 'ago' : ''})</em></>
            } else {
                return <><span>{timeToDisplay}{units}</span> {includeAgo? 'ago' : ''}</>
            }
        }
    }
}

export { getTimeStamp };